import { request } from "./request";
import * as apiConstants from "../constants/Api";

export const fetchApps = () => {
  return request("get", `${apiConstants.SERVER_URL}/form-service/logins`);
};

export const fetchApp = ({ appId }) => {
  return request(
    "get",
    `${apiConstants.SERVER_URL}/form-service/portal/logins/${appId}`
  );
};

export const fetchConnector = ({ connectorId }) => {
  return request(
    "get",
    `${apiConstants.SERVER_URL}/apps-service/connectors/${connectorId}`
  );
};

export const saveApp = ({ body, appId }) => {
  return request(
    "put",
    `${apiConstants.SERVER_URL}/form-service/portal/logins/${appId}`,
    body
  );
};

export const createApp = ({ body }) => {
  return request(
    "post",
    `${apiConstants.SERVER_URL}/form-service/portal/logins`,
    body
  );
};

export const getPassword = ({ appId }) => {
  return request(
    "get",
    `${apiConstants.SERVER_URL}/form-service/portal/logins/${appId}/password`
  );
};

export const removeApp = ({ appId }) => {
  return request(
    "delete",
    `${apiConstants.SERVER_URL}/form-service/portal/logins/${appId}`
  );
};
